import { render, staticRenderFns } from "./DisplayAttributes.vue?vue&type=template&id=bd3885b0&scoped=true&"
import script from "./DisplayAttributes.vue?vue&type=script&lang=js&"
export * from "./DisplayAttributes.vue?vue&type=script&lang=js&"
import style0 from "./DisplayAttributes.vue?vue&type=style&index=0&id=bd3885b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd3885b0",
  null
  
)

export default component.exports